import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/vehicles_/$vehicleId/insurance')({
  component: lazyRouteComponent(() => import('&/features/vehicles/pages/insurance-page')),
  staticData: { titleKey: 'insurance' },
});
